import { Category } from "../../features/checklist/model/ChecklistDtos";

export const StoreHelper = {
    Categories: {
        add(category: Category): void {
            const storedCategoriesJson = localStorage.getItem('storedCategories');
            const storedCategories: Category[] = storedCategoriesJson ? JSON.parse(storedCategoriesJson) : [];

            if (!storedCategories.map(e => e.name).includes(category.name)) {
              storedCategories.push(category);
              localStorage.setItem('storedCategories', JSON.stringify(storedCategories));
            }
        },
        update(categories: Category[]): Category[] {
            const storedCategoriesJson = localStorage.getItem('storedCategories');
            const storedCategories: Category[] = storedCategoriesJson ? JSON.parse(storedCategoriesJson) : [];

            const uniqueStoredCategories = storedCategories.filter(e => !categories.map(e => e.name).includes(e.name));

            localStorage.setItem('storedCategories', JSON.stringify(uniqueStoredCategories));

            return uniqueStoredCategories;
        }
    }
}
